;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Sale } from '@qogita/canary-client'
import { Badge } from '@qogita/ui/v2/badge'
import clsx from 'clsx'
import { differenceInMilliseconds } from 'date-fns'
import { ONE_DAY_MS } from 'src/core/constants/time'
import { getFormattedTimeUntilExpirationDate } from 'src/core/utils/get-formatted-time-until-expiration-date'

type OrderExpiryTimeBadgeProps = {
  expiredAt: Sale['expiredAt']
  badgeText?: string
  className?: string
}

export function OrderExpiryTimeBadge({
  expiredAt,
  className,
  badgeText,
}: OrderExpiryTimeBadgeProps) {
  if (!expiredAt) return null

  const orderExpiredAtInMilliseconds = differenceInMilliseconds(
    expiredAt,
    new Date(),
  )

  return (
    <Badge
      emphasis="high"
      className={clsx(className, 'whitespace-nowrap')}
      size="medium"
      variant={
        orderExpiredAtInMilliseconds <= 0
          ? 'red'
          : orderExpiredAtInMilliseconds <= ONE_DAY_MS
            ? 'caution'
            : 'default'
      }
      help={new Intl.DateTimeFormat('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        day: '2-digit',
        year: 'numeric',
        month: 'short',
        timeZoneName: 'short',
      }).format(new Date(expiredAt))}
    >
      {badgeText ??
        getFormattedTimeUntilExpirationDate(orderExpiredAtInMilliseconds)}
    </Badge>
  )
}
